/* Author:
    Adam Arp, Randy Hammons, Josh Rocha - Adcom
*/

// Add IE11 Class to html element (specifically to impliment object-fit image fix: https://is.gd/BdbYdi)
document.documentElement.className += '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style ? ' ie11' : '';

var Waypoints = require('../node_modules/waypoints/lib/jquery.waypoints.js');
var jqueryvalidation = require('../node_modules/jquery-validation/dist/jquery.validate.js');
var jqueryvalidationaddlmethods = require('../node_modules/jquery-validation/dist/additional-methods.js');

if ($("meta[lang='fr-CA']").length === 1) {

    var jqueryvalidationlocalizationfr = require('../node_modules/jquery-validation/dist/localization/messages_fr.js');

}
var CountUp = require('countup.js');
var owlcarousel = require('../node_modules/owl.carousel/dist/owl.carousel.min.js');
var handlebars = require('../node_modules/handlebars/dist/handlebars.min.js');
require('./plugins.js');

window.$ = $;

// Matching modules are required into this module.
function requireAll(requireContext) {
    return requireContext.keys().map(requireContext);
}

// Require.Context contains keys to each provided module.
var globalModules = requireAll(require.context("../themes/global/css", true, /\.css$/));
var modules = requireAll(require.context("../themes/kinetico/css", true, /.*/));

//Let's set up a privatized namespace
var kinetico = {
    settings: {
        dealerAPI: "/api/dealers/search",
        //marketingAPI: "http://kineticomarketingapi.kinetico.com/api/demographics/get",
        //marketingAPI: "http://kineticomarketing.made.incleve.land/api/demographics/get",
        //marketingAPI: "https://marketing-staging.kinetico.com/api/demographics/get",
        country: 'US', //We check, and subsequently change this later in the map utility
        mapView: false
    },
    windowResizing: false
};

window.kinetico = kinetico;


kinetico.mapReady = function () {
    kinetico.mapsAPIReady = true

    setTimeout(function () {
        if (kinetico.initDealerMap) {
            kinetico.initDealerMap()
        }
    }, 500)

}

var currentQuery;
var mapStyle = [{
    'featureType': 'administrative',
    'elementType': 'labels.text.fill',
    'stylers': [{
        'color': '#444444'
    }]
}, {
    'featureType': 'landscape',
    'elementType': 'all',
    'stylers': [{
        'color': '#f2f2f2'
    }]
}, {
    'featureType': 'poi',
    'elementType': 'all',
    'stylers': [{
        'visibility': 'off'
    }]
}, {
    'featureType': 'road',
    'elementType': 'all',
    'stylers': [{
        'saturation': -100
    }, {
        'lightness': 45
    }]
}, {
    'featureType': 'road.highway',
    'elementType': 'all',
    'stylers': [{
        'visibility': 'simplified'
    }]
}, {
    'featureType': 'road.arterial',
    'elementType': 'labels.icon',
    'stylers': [{
        'visibility': 'off'
    }]
}, {
    'featureType': 'transit',
    'elementType': 'all',
    'stylers': [{
        'visibility': 'off'
    }]
}, {
    'featureType': 'water',
    'elementType': 'all',
    'stylers': [{
        'color': '#3b86bd'
    }, {
        'visibility': 'on'
    }]
}];

//Handle browser resizes at a global level, versus having multiples everywhere...
kinetico.resize = function () {
    function mqCheck() {
        var mq = window.matchMedia('only screen and (min-width: 48em)');

        if (mq.matches) {
            currentQuery = 'wide';
        } else {
            currentQuery = 'narrow';
        }
        mq.addListener(function (changed) {
            if (changed.matches) {
                currentQuery = 'wide';
            } else {
                currentQuery = 'narrow';
            }
        });
    }

    mqCheck();

    $(window).resize(function () {
        mqCheck();
        if (currentQuery === 'wide') {
            $('#header').removeClass('active');
            $('html').removeClass('noscroll');
        }
        //kinetico.headerUtils();

    });
};

//Updated postal code validation, handles US zip codes and qualified Canadian postal codes using allowed patter nand letter-set.
function postalFilter(postalCode, requireCountry) {
    if (!postalCode) {
        return null;
    }

    postalCode = postalCode.toString().trim();

    var us = new RegExp("^\\d{5}(-{0,1}\\d{4})?$");
    var ca = new RegExp(/([ABCEGHJKLMNPRSTVXY]\d)([ABCEGHJKLMNPRSTVWXYZ]\d){2}/i);

    if (us.test(postalCode.toString()) && (!requireCountry || (requireCountry === 'US'))) {
        return postalCode;
    }

    if (ca.test(postalCode.toString().replace(/\W+/g, '')) && (!requireCountry || (requireCountry === 'CA'))) {
        return postalCode;
    }
    return null;
}
//// these 5 return null
//console.log('these 5 return null:');
//console.log(postalFilter('1a1 a1a'));
//console.log(postalFilter('F1A AiA'));
//console.log(postalFilter('A12345-6789'));
//console.log(postalFilter('W1a1a1')); // no "w"
//console.log(postalFilter('Z1a1a1')); // ... or "z" allowed in first position!

//// these return canada postal less space
//console.log('these return canada postal less space');
//console.log(postalFilter('a1a 1a1'));
//console.log(postalFilter('H0H 0H0'));

//// these return unaltered
//console.log('these return unaltered');
//console.log(postalFilter('H0H0H0'));
//console.log(postalFilter('a1a1a1'));
//console.log(postalFilter('12345'));
//console.log(postalFilter('12345-6789'));
//console.log(postalFilter('123456789'));

//// strip spaces
//console.log('strip spaces');
//console.log(postalFilter(' 12345 '));

//// these are my validation tests D, F, I, O, Q or U.
//console.log('these are my  tests');
//console.log(postalFilter(' 44870 '));
//console.log(postalFilter('d1d 1d1'));
//console.log(postalFilter('q1q 1q1'));
//console.log(postalFilter('q1q 1q1'));
//console.log(postalFilter('f1f 1f1'));
//console.log(postalFilter('i1i 1i1'));
//console.log(postalFilter('o1o 1o1'));
//console.log(postalFilter('a1u 1u1'));
//console.log(postalFilter('15121'));

/*
    HeaderUtils
    Handles all the experiential behavior within header.
*/
kinetico.headerUtils = function () {

    $('#main').css({ 'margin-top': 'auto' });

    var docHeight = $(document).height(),
        pageHeader = $('#header'),
        headerHeight = $(pageHeader).outerHeight();

    //Mobile nav toggler
    $('.navToggle').on('click', function (event) {
        event.preventDefault();
        $('#header').toggleClass('active');
        $('html').toggleClass('noscroll');
        var headerLinks = $('#header').find('a');

        if (!$('.tertiaryNav').length) {
            var navFooter = document.createElement('div');
            navFooter.setAttribute('class', 'tertiaryNav');
            $('.header__masthead').append(navFooter);
            $('.globalNav__navList__listItem__link--waterExpert').clone().appendTo(navFooter);
            $('.globalNav__navList__listItem__link--commercial').clone().appendTo(navFooter);
            $('.globalNav__navList__listItem__link--residential').clone().appendTo(navFooter);
        }
    });

    if (currentQuery === 'wide') {
        var headerHeightUpdate = function (newHeight) {

            $('#main').css({
                'margin-top': (newHeight ? newHeight : $(pageHeader).outerHeight()) + 'px'
            });
        };

        headerHeightUpdate(headerHeight);

        var resizeTimer;

        $(window).resize(function () {
            kinetico.windowResizing = true;
            if (resizeTimer) { clearTimeout(resizeTimer); }
            resizeTimer = setTimeout(function () {
                $(this).delay(850).queue(function () {
                    headerHeightUpdate(currentQuery === 'wide' ? $(pageHeader).outerHeight() : 0);
                    resizeTimer = undefined;
                    kinetico.windowResizing = false;
                }).dequeue();
            }, 300);
        });
    }

};


/*
    MapHandler
    Handles map for dealer location and heatmapping
    Uses:
*/
kinetico.mapHandler = function () {
    /*
        1. Determine which map to show - has user previously submitted location information?
        2. Only generate the map when it is in view.
        3. If no stored requet information, display heatmap based on current region/country known by url
        4. Handle geolocation lookup (on results and on locate me)
        5. Convert map display and show results with numbered, markers.
    */
    var map,
        mapFigure = $('.map .map__message')[0],
        mapState = 'heatmap', //Need to check local storage for this state from return visitors
        heatmap,
        heatmapArray = [],
        mapResponse = $('.map__expertFinderResponse')[0],
        searchInput = $('.map__expertFinderInput')[0], //Search Input
        searchSubmit = $('.map__expertFinderForm .button--search')[0], //Search Submit,
        locateButton = $('.map__expertFinderForm .button--locator')[0],
        existingLocation; //Locate me with GeoLocator API

    if (!searchSubmit) return false;

    //Check locality for mapping.
    //if ($('link[rel="alternate"]').attr('hreflang') === 'en-CA' || $('link[rel="alternate"]').attr('hreflang') === 'fr-CA') {
    //	kinetico.settings.country = 'CA';
    //}

    if ($("meta[lang='en-US']").length === 1) {
        //console.log('validated country as us english');
        kinetico.settings.country = 'US';
    } else {
        //console.log('not us english, use canada as country code');
        kinetico.settings.country = 'CA';
    }
    //Check for local storage, if there, check if user previously searched
    if (typeof (Storage) !== "undefined") {
        var storageReady = true;
        existingLocation = localStorage.getItem("postalcode");
        console.log('local storage supported!', localStorage.getItem("postalcode"));
        console.log('reset your storage using: "localStorage.removeItem("postalcode");" ')
        if (existingLocation) {
            //We've got a location, search it
            //getExperts(existingLocation);
            $(searchInput).val(existingLocation);
            kinetico.dealerProfile();
        }
    } else {
        console.log('Local storage not supported! Sorry!');
    }

    //console.log(kinetico.settings.country);
    //Load map when in view!
    var mapWaypoint = new Waypoint({
        element: mapFigure,
        handler: function (direction) {
            //console.log('Scrolled to map waypoint!');
            if (kinetico.settings.mapView) {
                //console.log('has a mapview status');
            } else {
                //console.log('no mapview status, setting one and initializing map');
                if (localStorage.getItem("postalcode") != null) {
                    //console.log('have postal code');
                    getExperts(existingLocation);
                    $(searchInput).val(existingLocation);
                } else {
                    //console.log('do not have postal code');
                }

                kinetico.settings.mapView = true;
            }
        },
        offset: '125%' //Start just before we are there
    });

    var experts = [],
        markers = [],
        markerIcons = [
            "/themes/kinetico/img/expertmarker1.png",
            "/themes/kinetico/img/expertmarker2.png",
            "/themes/kinetico/img/expertmarker3.png",
            "/themes/kinetico/img/expertmarker4.png",
            "/themes/kinetico/img/expertmarker5.png",
            "/themes/kinetico/img/expertmarker6.png",
            "/themes/kinetico/img/expertmarker7.png",
            "/themes/kinetico/img/expertmarker8.png",
            "/themes/kinetico/img/expertmarker9.png",
            "/themes/kinetico/img/expertmarker10.png"
        ];

    function rearrange(array) {
        var currentIndex = array.length, temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }




    function getExperts(postalcode) {
        labelIndex = 0;
        //Load in the GEOJSON and parse out the featured points
        //console.log('looking for experts in:', postalcode);

        localStorage.setItem("postalcode", postalcode);

        return $.ajax({
            url: kinetico.settings.dealerAPI,
            data: {
                postalCode: postalcode,
                country: kinetico.settings.country
            },
            dataType: "json",
            success: function (data) {
                deleteMarkers();

                // Per client request we are reintroducing 
                // randomization of experts returned in search. 
                // Takes the array, randomizes it, adds back to 
                // the original array and removes old expert items
                var randomizedExpertData = data.experts;
                var expertCount = data.experts.length;
                randomizedExpertData = rearrange(randomizedExpertData);

                //A means to maintain our expert count
                data.expertCount = expertCount;

                $(randomizedExpertData).each(function (i, expert) {
                    data.experts.push(expert);
                    delete data.experts[i];
                });

                //Compile Handlebars Template
                var noresultsHandler = handlebars.compile($("#results-nonefound").html());
                var itemsHandler = handlebars.compile($("#results-template").html());


                if (data.experts.length === 0) {
                    $(mapResponse).html(noresultsHandler(data));
                } else {
                    $(mapResponse).html(itemsHandler(data));
                }
            },
            error: function (response) {
                console.error('Dealer Locator Error:', response);
            }
        });
    }

    // Sets the map on all markers in the array.
    function setMapOnAll(map) {
        for (var i = 0; i < markers.length; i++) {
            markers[i].setMap(map);
        }
    }

    // Removes the markers from the map, but keeps them in the array.
    function clearMarkers() {
        setMapOnAll(null);
    }

    // Shows any markers currently in the array.
    function showMarkers() {
        setMapOnAll(map);
    }

    // Deletes all markers in the array by removing references to them.
    function deleteMarkers() {
        clearMarkers();
        markers = [];
    }

    function geoLocator() {
        if (navigator.geolocation) {
            var fallback = setTimeout(function () {
                fail('10 seconds expired');
            }, 10000);
            navigator.geolocation.getCurrentPosition(
                function (pos) {
                    clearTimeout(fallback);
                    //console.log('pos', pos);
                    var point = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
                    new google.maps.Geocoder().geocode({
                        'latLng': point
                    }, function (res, status) {
                        if (status === google.maps.GeocoderStatus.OK && typeof res[0] !== 'undefined') {

                            if (typeof res[0].address_components[7].long_name != 'undefined') {
                                var zip = res[0].address_components[7].long_name; //res[0].formatted_address.match(/,\s\w{2}\s(\d{5})/);
                            } else {
                                alert('We are unable to locate you, please enter your zip or postal code.');
                            }

                            console.log('geolocation response', res[0]);
                            console.log('address object', res[0].address_components[7]);

                            localStorage.setItem("postalcode", zip);

                            zipCaptureSuccess(zip);
                            getExperts(zip);
                        } else {
                            fail('Failed to reverse');
                        }
                    });
                },
                function (err) {
                    fail(err.message);
                }, {
                maximumAge: 600000,
                timeout: 5000,
                enableHighAccuracy: true
            }
            );
        } else {
            error('Geolocation unsupported!');
        }

        function fail(err) {
            console.log('err', err);
            //alert('Something went wrong -- You are likely browsing from an unsecured location.')
        }
    }

    function zipCaptureSuccess(zipCode) {
        var searchInput = $('.map__expertFinderInput')[0]
        $(searchInput).val(zipCode);
    }

    function getPoints() {
        return heatmapArray;
    }

    //Catch all action--waterExpert links and scroll user to bottom of page.
    $('.action--waterExpert').click(function (event) {
        event.preventDefault();

        $('#header').removeClass('active');
        $('html').removeClass('noscroll');
        if ($('.map__message__headline').eq(0) > 0) {
            $('html, body').animate({
                scrollTop: $('.map__message__headline').offset().top - 50
            }, 1000);
        } else {
            $('html, body').animate({
                scrollTop: $('.map').offset().top
            }, 1000);
        }

    })

    //User opts to share location, get results
    $(locateButton).click(function (event) {
        geoLocator();
    });

    function onSearchInputChange(event) {
        if (postalFilter($(searchInput).val(), kinetico.settings.country) === null) {
            searchSubmit.parentNode.classList.add('map__expertFinderForm--invalid')
            searchSubmit.disabled = true
            searchSubmit.classList.add('button--disabled')
        } else {
            searchSubmit.parentNode.classList.remove('map__expertFinderForm--invalid')
            searchSubmit.disabled = false
            searchSubmit.classList.remove('button--disabled')
        }
    }

    function initialSearchInputCheck() {
        var value = $(searchInput).val()
        if (value === '') {
            searchSubmit.disabled = true
        } else {
            onSearchInputChange()
        }
    }
    setTimeout(initialSearchInputCheck, 10)

    searchInput.addEventListener('keydown', function () {
        setTimeout(onSearchInputChange, 200)
    })
    searchInput.addEventListener('change', onSearchInputChange)

    //Search Submission
    $(searchSubmit).click(function (event) {

        event.preventDefault();

        if (searchSubmit.disabled) {
            return
        }

        if (postalFilter($(searchInput).val()) !== null) {
            $(searchSubmit).addClass('button--active');

            getExperts($(searchInput).val()).then(function () {
                $(searchSubmit).removeClass('button--active');
            });

        } else {
            $(mapFigure).addClass('error');
            var noItemsHandler = handlebars.compile($("#results-nonefound").html());
            $(mapResponse).html(noItemsHandler());
            clearMarkers();
            map.setZoom(4);
        }
    });

    $(searchInput).keypress(function (event) {
        if (event.keyCode === 13) {
            event.preventDefault();

            if (postalFilter($(searchInput).val()) !== null) {
                $(searchSubmit).addClass('button--active');

                getExperts($(searchInput).val()).then(function () {
                    $(searchSubmit).removeClass('button--active');
                });
            } else {
                $(mapFigure).addClass('error');
                var noItemsHandler = handlebars.compile($("#results-nonefound").html());
                $(mapResponse).html(noItemsHandler());

                clearMarkers();
            }
        }
    });
};

/*
    Testimonials
    Creates carousel experience of testimonials on tablet+ sizes.
    Randomize for variance in display
    Uses:
    Shuffle Plugin
*/
kinetico.testimonials = function () {
    //Testimonials in result listing -- show and hide.
    $(document).on('click', '.map__expertFinderResultTestimonialTrigger', function () {
        $(this).parent('aside').toggleClass('active');
    });

    //Randomize testimonials in homepage banner
    $('.banner--testimonials .testimonial').shuffle();

    //Generate carousel in wider environments
    $('.banner--testimonials .maxWrapper').owlCarousel({
        loop: true,
        margin: 10,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
                nav: false,
                loop: true
            },
            600: {
                items: 1,
                nav: false,
                loop: true
            },
            1000: {
                items: 1,
                nav: true,
                loop: true
            }
        }
    })


}

/*
    Location Picker
    Clicking on current location drops down menu to select other locations
    Uses:
*/
kinetico.regionPicker = function () {

    // Variables
    var regionPicker = $('.regionPicker'),
        rpHeight = regionPicker.height(),
        rpStyles = {
            height: rpHeight
        },
        regionPickerList = $('.regionPicker__list'),
        rplHeight = regionPickerList.height(),
        animSpeed = 250;

    // Open The Region Picker
    regionPicker.click(function (e) {
        if (!$(this).hasClass('active')) {
            rpHeight = regionPicker.height();
            rpStyles = {
                height: rpHeight
            };

            if (currentQuery === 'wide') {
                regionPicker.css(rpStyles);
            }
            $(this).addClass('active');
            rplHeight = regionPickerList.height();
            regionPickerList.css('height', rpHeight).animate({
                height: rplHeight
            }, animSpeed);
        }
    });

    // Handle Option Selection
    $('.regionPicker__option').click(function (e) {
        if ($(this).hasClass('active')) {
            e.preventDefault();
            rpHeight = regionPicker.height();
            rpStyles = {
                height: rpHeight
            };
            if (currentQuery === 'wide') {
                regionPicker.hide();
                regionPicker.css(rpStyles);
                regionPicker.fadeIn();
            }
            $(this).removeClass('active');
            regionPicker.addClass('active');
            rplHeight = regionPickerList.height();
            regionPickerList.css('height', rpHeight).animate({
                height: rplHeight
            }, animSpeed);
        } else {
            $(this).addClass('active');
            regionPicker.removeClass('active');
        }
    });

    // Close The Region Picker
    $(document).click(function (e) {
        if (!$(e.target).closest('.regionPicker').length &&
            !$(e.target).is('.regionPicker')) {
            if (regionPicker.hasClass('active')) {
                rpStyles = {
                    height: 'auto'
                };
                $('.regionPicker__option.currentRegion').addClass('active');
                regionPickerList.animate({
                    height: rpHeight
                }, animSpeed, function () {
                    regionPickerList.css('height', 'auto');
                    regionPicker.removeClass('active');
                    regionPicker.css(rpStyles);
                });
            }
        }
    })
}

/*
    Product Comparison Utility
    Determines whether tooltip should display to right or left.
    Uses:
    Some cool stuff I came up with
*/
kinetico.productComparisonUtil = function () {
    function isOdd(num) {
        return num % 2;
    }


    $('.comparisonGuide__list__item').each(function () {

        var features = $(this).find('.comparisonGuide__list__item__features__feature');
        $(features).each(function (i, feature) {
            if (isOdd(i)) {
                $(this).addClass('even');
            }
        });

    });

    $('.comparisonGuide__list__item__features__feature').mouseover(function () {
        var docWidth = $('body').width();
        leftOffset = $(this).offset().left;
        relatedTooltip = $(this).next().children('div');
        leftStyles = {
            left: "auto",
            right: "50%"
        }

        if (currentQuery == 'wide') {
            relatedTooltip.addClass('fadeIn');
            if (leftOffset > (docWidth / 2)) {
                relatedTooltip.css(leftStyles);
            }
        }
    });

    //Only height match if necessary
    if (currentQuery == 'wide') {
        kinetico.matchHeight();
    }

    $('.comparisonGuide__list__item__features__feature').click(function () {
        relatedTooltip = $(this).next().children('div');

        if (currentQuery == 'narrow') {
            if (relatedTooltip.hasClass('active')) {
                $('.comparisonGuide__list__item__features__tooltip div').removeClass('active');
            } else {
                $('.comparisonGuide__list__item__features__tooltip div').removeClass('active');
                relatedTooltip.addClass('fadeIn');
                relatedTooltip.addClass('active');
            }
        }
    });
}
/*
    Match Height Utility
    Makes the height of all selected elements exactly equal.
    Uses:
    jquery.matchHeight.js
*/
kinetico.matchHeight = function () {
    $('.comparisonGuide__list__item__name').matchHeight();
    $('.comparisonGuide__list__item__highlight').matchHeight();
    $('.comparisonGuide__list__item__features__feature').matchHeight();
    $('.comparisonGuide__list__item__features').matchHeight();
    $('.productListing__product__header').matchHeight();
}

/*	Stats
    Looks for visible stats on the page, once in view begins
    to count up to a number and transition from pale near white
    to full blue color-way.
    Uses:
    Waypoints.js,
    CountUp.js,
    Shuffle Plugin
*/
kinetico.stats = function () {
    var stats = $('.stats .stats__stat'),
        statContainer = $('.stats'),
        statlock = false;
    if (!stats.length > 0) {
        return false;
    }
    $('.stats .stats__stat').shuffle();

    var countUpVisible = function () {
        if (statlock) return false;

        var visibleStats = $('.stats__stat:not(:hidden)');
        //Using countup.js plugin
        var options = {
            useEasing: true,
            useGrouping: true,
            separator: ',',
            decimal: '.',
            prefix: '',
            suffix: ''
        };

        $(visibleStats).each(function (index, stat) {
            var statTarget = $(stat).find('.stats__stat__number strong')[0],
                statNumber = parseFloat($(statTarget).text()).toFixed(1);

            if (statNumber.indexOf(".0") == -1) {
                var statCount = new CountUp(statTarget, 0, statNumber, 1, 2.5, options);

            } else {
                var statCount = new CountUp(statTarget, 0, statNumber, 0, 2.5, options);

            }
            //console.log(statNumber);
            $(stat).delay(index * 400).queue(function () {
                $(stat).addClass('visible');
                statCount.start()
            });
        });

        statlock = true;
    }

    var statWaypoint = new Waypoint({
        element: statContainer[0],
        handler: function (direction) {
            //console.log('Scrolled to stat waypoint!');

            //Begin animation count up.
            countUpVisible();
        },
        offset: '75%'
    });
}

//FAQ Functionality
kinetico.faqs = function () {
    var faqSections = $('.faqSection'),
        faqTopicNav = $('.topicNav--faq')[0];



    //Hide and show answers
    $(document).on('click', '.faqSection__question', function () {
        $(this).next('dd').toggleClass('faqSection__answer--active').fadeToggle();
    });


    $(faqSections).each(function (index, section) {
        var questions = $(this).find('.faqSection__question');
    });

    //Scroll page down to topic
    $(document).on('click', '.topicNav--faq a', function (event) {
        event.preventDefault();
        var topicLocation = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(topicLocation).offset().top - 200
        }, 1000);
    });

    if (window.location.hash) {
        $('html, body').animate({
            scrollTop: $(window.location.hash).offset().top - 250
        }, 1000);
    }


}

kinetico.dealerProfile = function () {
    var dealerProfile = $('.dealerProfile');
    if (!dealerProfile.length > 0) {
        //console.log('not on a dealer profile, stop.');
        return false;
    }

    //https://maps.googleapis.com/maps/api/geocode/json?address=1600+Amphitheatre+Parkway,+Mountain+View,+CA&key=YOUR_API_KEY

    var dealerMap = $('.map__display--dealer'),
        dealerName = $('.banner__header').text(),
        dealerAddress = $('.dealerProfile__contactInfo dd[itemprop="streetAddress"]').text() + $('.dealerProfile__contactInfo dd[itemprop="addressLocality"]').text(),
        dealerInfo = [],
        dealerLocations = $('.dealerProfile__location');

    function initDealerMap() {
        //console.log('initializing dealer profile map');

        if (
            !kinetico.mapsAPIReady
            || kinetico.dealerMapInitted
            || (dealerInfo.length < dealerLocations.length)
        ) {
            return
        }
        kinetico.dealerMapInitted = true;


        dealermap = new google.maps.Map(document.getElementById('dealermap'), {
            zoom: 15,
            maxZoom: 20,
            minZoom: 3,
            scrollwheel: true,
            navigationControl: false,
            mapTypeControl: false,
            scaleControl: false,
            mapTypeId: google.maps.MapTypeId.ROAD
        });

        var bounds = new google.maps.LatLngBounds();

        $(dealerInfo).each(function (index, item) {
            var marker = new google.maps.Marker({
                position: item.location,
                map: dealermap,
                icon: "/themes/kinetico/img/expertmarker.png",
                title: dealerName,
                animation: google.maps.Animation.DROP
            });

            bounds.extend(item.location);

            marker.addListener('click', function () {
                createInfoWindow(marker);
            });

            //markers.push(marker);
            var infowindow = new google.maps.InfoWindow();

            function createInfoWindow(marker) {
                infowindow.close();
                var link = 'https://maps.google.com?daddr=' + item.address;
                infowindow.setContent(
                    "<h2 style='color: #3b86bd'>" + item.name + "</h2>" +
                    "<p><a href='" + link + "' target='_blank' class='dealerProfile__directionsLink'>Get Directions</a></p>"
                );
                infowindow.open(dealermap, marker);
            }
        });

        dealermap.fitBounds(bounds);

        //console.log('created my dealer profile map', dealermap);
    }

    kinetico.initDealerMap = initDealerMap

    var totalGeocodeRequestCheck = (function () {
        var counter = 0;

        return function () {
            counter += 1;
            if (counter === dealerLocations.length) initDealerMap();
        }
    })();

    dealerLocations.each(function (index, item) {

        if ($(item).find('dd[itemprop = "streetAddress"]').text().trim() != '') {
            console.log($(item).find('dd[itemprop = "streetAddress"]').text().trim());
            var dealerName = $(item).find('.dealerProfile__location-name').text(),
                dealerCombinedAddress = $(item).find('dd[itemprop = "streetAddress"]').text().trim() + ' ' + $(item).find('span[itemprop="addressLocality"]').text().trim() + ', ' + $(item).find('span[itemprop="addressRegion"]').text().trim() + ' ' + $(item).find('span[itemprop="postalCode"]').text().trim();

            var geocoder = new google.maps.Geocoder();

            geocoder.geocode({ 'address': dealerCombinedAddress }, function (results, status) {

                if (status === 'OK') {

                    var info = {

                        name: dealerName,

                        address: dealerCombinedAddress,

                        location: results[0].geometry.location

                    }

                    dealerInfo.push(info);

                }

                else {

                    console.log("ERROR");

                }
                initDealerMap();

            });
        }
    });

}

kinetico.search = function () {
    var searchResults = $('.searchResults__list')[0],
        loadMoreButton = $('.button--loadMore')[0],
        currentPage = 1,
        nextPage = window.location + '?p=' + $(loadMoreButton).data('nextpage');

    if (loadMoreButton) {
        //console.log('we have more than one!');
        $(loadMoreButton).click(function (event) {
            var loadedResults = '<div id="loadedResults">Loading Results</div>';
            if (currentPage < $(loadMoreButton).data('nextpage')) {
                $(loadedResults).appendTo(searchResults);
                $('#loadedResults').load("" + nextPage + " #searchResults__list li", function (event) {
                    currentPage = $(loadMoreButton).data('nextpage');
                });

            } else {
                $(loadMoreButton).hide();
            }
        });
    }

}

kinetico.formvalidation = function () {
    var forms = $('#main form');
    formSubmit = $(forms).find('button');

    $(forms).attr('novalidate', 'novalidate');

    $(forms).validate();

    if ($("meta[lang='fr-CA']").length === 1) {
        $.validator.addMethod("postalvalidation", function (value, element) {
            return postalFilter(value);
        }, "Code postal invalide entré");
    } else {
        $.validator.addMethod("postalvalidation", function (value, element) {
            return postalFilter(value);
        }, "Invalid postal code entered");
    }

    $('#main form .postalcode input').rules("add", {
        postalvalidation: true
    });

}

kinetico.tracking = function () {
    //console.log('beginning GA tracking of anchors');
    var filetypes = /\.(zip|exe|dmg|pdf|doc.*|xls.*|ppt.*|mp3|txt|rar|wma|mov|avi|wmv|flv|wav)$/i;
    var baseHref = '';
    if ($('base').attr('href') != undefined) baseHref = $('base').attr('href');

    $('a').on('click', function (event) {
        //event.preventDefault(); //Turn on to troubleshoot
        var el = $(this);
        var track = true;
        var href = (typeof (el.attr('href')) != 'undefined') ? el.attr('href') : "";
        var isThisDomain = href.match(document.domain.split('.').reverse()[1] + '.' + document.domain.split('.').reverse()[0]);
        if (!href.match(/^javascript:/i)) {
            var elEv = [];
            elEv.value = 0, elEv.non_i = false;
            if (href.match(/^mailto\:/i)) {
                elEv.category = "email";
                elEv.action = "click";
                elEv.label = href.replace(/^mailto\:/i, '');
                elEv.loc = href;
            } else if (href.match(filetypes)) {
                var extension = (/[.]/.exec(href)) ? /[^.]+$/.exec(href) : undefined;
                elEv.category = "download";
                elEv.action = "click-" + extension[0];
                elEv.label = href.replace(/ /g, "-");
                elEv.loc = baseHref + href;
            } else if (href.match(/^https?\:/i) && !isThisDomain) {
                elEv.category = "external";
                elEv.action = "click";
                elEv.label = href.replace(/^https?\:\/\//i, '');
                elEv.non_i = true;
                elEv.loc = href;
            } else if (href.match(/^tel\:/i)) {
                elEv.category = "telephone";
                elEv.action = "click";
                elEv.label = href.replace(/^tel\:/i, '');
                elEv.loc = href;
            } else track = false;

            if (track) {
                var trackerName = ga.getAll()[0].get('name');
                ga(trackerName + '.send', 'event', elEv.category.toLowerCase(), elEv.action.toLowerCase(), elEv.label.toLowerCase(), elEv.value, elEv.non_i);

            }
        }
    });
}


kinetico.disclaimerUtil = function () {
    if ($('.hidden.productDisclaimerText').length < 0) return false;

    $('.tertiaryFooter__disclaimer').eq(0).append("<p>" + $('.hidden.productDisclaimerText').text() + "</p>");
}

kinetico.dealerResultsformControl = function () {
    var dealerContainer = $('.map__expertFinderResponse');
    if (dealerContainer.length) {
        $(dealerContainer).on('click', '.map__control', function () {
            var formType = $(this).hasClass('map__control--quote') ? 'quote' : 'waterTest',
                parent = $(this).parent();

            if (formType == 'quote') {
                parent.removeClass('map__formToggle--waterTest').addClass('map__formToggle--quote');
            } else {
                parent.removeClass('map__formToggle--quote').addClass('map__formToggle--waterTest');
            }
        });
    }
}


$(document).ready(function () {
    kinetico.resize();
    kinetico.stats();
    kinetico.mapHandler();
    kinetico.testimonials();
    kinetico.headerUtils();
    kinetico.regionPicker();
    kinetico.productComparisonUtil();
    kinetico.faqs();
    kinetico.dealerProfile();
    kinetico.search();
    kinetico.formvalidation();
    kinetico.tracking();
    kinetico.disclaimerUtil();
    kinetico.dealerResultsformControl();
    //kinetico.matchHeight();

});

// Handlebars extended helpers
handlebars.registerHelper("math", function (lvalue, operator, rvalue, options) {
    lvalue = parseFloat(lvalue);
    rvalue = parseFloat(rvalue);

    return {
        "+": lvalue + rvalue,
        "-": lvalue - rvalue,
        "*": lvalue * rvalue,
        "/": lvalue / rvalue,
        "%": lvalue % rvalue
    }[operator];
});

handlebars.registerHelper('compare', function (lvalue, operator, rvalue, options) {

    var operators, result;


    if (options === undefined) {
        options = rvalue;
        rvalue = operator;
        operator = "===";
    }

    operators = {
        '==': function (l, r) {
            return l == r;
        },
        '===': function (l, r) {
            return l === r;
        },
        '!=': function (l, r) {
            return l != r;
        },
        '!==': function (l, r) {
            return l !== r;
        },
        '<': function (l, r) {
            return l < r;
        },
        '>': function (l, r) {
            return l > r;
        },
        '<=': function (l, r) {
            return l <= r;
        },
        '>=': function (l, r) {
            return l >= r;
        },
        'typeof': function (l, r) {
            return typeof l == r;
        }
    };

    if (!operators[operator]) {
        throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
    }

    result = operators[operator](lvalue, rvalue);

    if (result) {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }

});

$(document).ready(function () {
    $('p iframe').each(function () {
        $(this).parent().addClass('fixembed-ratio');
    });
});


//////////////////
// WEBPACK FOOTER
// ./main.js
// module id = 0
// module chunks = 0